'use client';

/**
 * Back-compat shim — primary navigation lives in `./primary-navigation/`.
 * Import `PrimaryNavigation` directly for new code.
 */
export {
  default,
  PrimaryNavigation,
  type NavigationBarHorizontalType,
  type PrimaryNavigationProps,
  type TimelineDropdownItem,
} from './primary-navigation';
